/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
import { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../juristec-ui/core/DatePicker';
// import Select from '../../juristec-ui/core/Select';
import Select from '../../juristec-ui/core/SelectNew';
import IconButton from '../../juristec-ui/core/IconButton';
import InputTextLine from '../../juristec-ui/core/InputTextLine';
import SelectTips from '../Popovers/SelectTips';

import { trimString } from '../../juristec-ui/utils/functions/formatString';

import { Add, Close } from '../../juristec-ui/icons';
import { getDynamicDateRange } from '../../options';

import {
  ItemContainer,
  BadgeContainer,
  ScrollContainer,
  FilterBadge,
  BadgeClose,
} from './styled/KpiFilter.styled';

const checkDate = (value) => {
  const val = new Date(value instanceof Date ? value : `${value}T00:00`);
  return Number.isNaN(val.getTime()) ? new Date() : val;
};

const FilterByValues = ({ options, values, handle }) => (
  <Select
    label="Valores"
    onChange={handle}
    value={values}
    options={options}
    searchable
    selectAll
    sortBy="ascending"
    multiple
    stayOpen
    atModal
    // menuPlacement="auto"
    // maxMenuHeight={150}
    // menuPosition="fixed"
    // formatOptionLabel={false}
    // closeMenuOnSelect={false}
    // fullWidth
  />
);

const handleFilterByNDescription = (fType, N) => {
  const res = getDynamicDateRange(fType, +(N));
  if (res === 'Filtro não reconhecido') {
    return '';
  }
  if (fType.includes('not')) {
    return `Datas menores ou iguais a ${res.firstInterval.endDate} e maiores ou iguais a
    ${res.secondInterval.startDate}.
    `;
  }
  return `Datas entre ${res.firstInterval.startDate} e ${res.firstInterval.endDate}.`;
};

const FilterByN = ({
  values, handle, orientation, filterType, atModal, selector = '',
}) => {
  const description = handleFilterByNDescription(`${filterType}${selector}`, values[0]);
  return (
    <ItemContainer orientation={orientation} style={{ position: 'relative', width: '100%', ...(atModal ? { zIndex: 1050 } : {}) }}>
      <InputTextLine
        label="Valor de N"
        value={values[0]?.toString().replace('.', ',')}
        onChange={(e) => handle(trimString(e.target.value))}
      />
      {values[0] !== '' && description !== '' && (
        <SelectTips
          description={description}
          style={{ top: '-5px', right: '2px' }}
        />
      )}
    </ItemContainer>
  );
};

const FilterBetweenAB = ({
  values, handle, orientation, atModal,
}) => (
  <ItemContainer orientation={orientation} style={atModal ? { zIndex: 1050 } : {}}>
    <InputTextLine
      label="Valor de A"
      value={values[0]?.toString().replace('.', ',')}
      onChange={(e) => handle({ start: trimString(e.target.value) })}
    />
    <InputTextLine
      label="Valor de B"
      value={values[1]?.toString().replace('.', ',')}
      onChange={(e) => handle({ end: trimString(e.target.value) })}
    />
  </ItemContainer>
);

const FilterBetweenDates = ({
  values, handle, orientation, atModal,
}) => {
  const valA = checkDate(values[0]);
  const valB = checkDate(values[1]);
  return (
    <ItemContainer orientation={orientation} style={atModal ? { zIndex: 1050 } : {}}>
      <DatePicker
        value={valA}
        onChange={(val) => handle({ start: val })}
        label="Valor de A"
        startDate={valA}
        endDate={valB}
        maxDate={valB}
        atModal
      />
      <DatePicker
        value={valB}
        onChange={(val) => handle({ end: val })}
        label="Valor de B"
        startDate={valA}
        endDate={valB}
        minDate={valA}
        atModal
      />
    </ItemContainer>
  );
};

const FilterByNDate = ({
  values, handle, orientation, atModal,
}) => (
  <ItemContainer orientation={orientation} style={atModal ? { zIndex: 1050 } : {}}>
    <DatePicker
      value={checkDate(values[0])}
      onChange={(val) => handle(val)}
      label="Valor de N"
      atModal
    />
  </ItemContainer>
);

const FilterBySpecificDate = ({
  values, handle, orientation, atModal,
}) => (
  <ItemContainer orientation={orientation} style={atModal ? { zIndex: 1050 } : {}}>
    <Select
      label="Momento específico"
      options={[
        { value: 'hoje', label: 'Hoje', id: 'today' },
        { value: 'ontem', label: 'Ontem', id: 'yesterday' },
        { value: 'amanhã', label: 'Amanhã', id: 'tomorrow' },
      ]}
      value={values[0]}
      onChange={(val) => handle(val)}
      searchable
      atModal={atModal}
    />
  </ItemContainer>

);

const FilterBySearch = ({
  values, handle, orientation, atModal,
}) => {
  const [inputVal, setInputVal] = useState('');
  const handleInput = (e) => setInputVal(e.target.value);

  const addVal = () => {
    const val = inputVal.trim();
    if (inputVal.trim().length > 0) {
      handle({ val, operation: 'add' });
      setInputVal('');
    }
  };

  const delVal = (val) => {
    handle({ val, operation: 'delete' });
  };

  const keyHandle = (e) => {
    if (e.key === 'Enter') addVal();
  };

  return (
    <>
      <ItemContainer style={atModal ? { zIndex: 1050 } : {}}>
        <InputTextLine
          label="Valor de busca"
          value={inputVal}
          onChange={handleInput}
          onKeyDown={keyHandle}
        />
        <IconButton
          color="secondary"
          shape="rounded"
          variant="contained"
          onClick={addVal}
          style={{ height: '35px', width: '35px', margin: 'auto' }}
        >
          <Add />
        </IconButton>
      </ItemContainer>
      <ScrollContainer orientation={orientation} style={atModal ? { zIndex: 1050 } : {}}>
        <BadgeContainer>
          {values.map((val, i) => (
            <FilterBadge
              key={`${val}${i}`}
              color="secondary"
              textTransform="uppercase"
              size="small"
            >
              <span>{val}</span>
              <BadgeClose onClick={() => delVal(val)}>
                <Close />
              </BadgeClose>
            </FilterBadge>
          ))}
        </BadgeContainer>
      </ScrollContainer>
    </>
  );
};

const KpiFilter = ({
  filterType = 'values',
  options = [],
  values = [],
  handle = () => {},
  format = '',
  orientation = 'row',
  atModal = false,
  selector = '',
}) => {
  if (filterType !== 'values' && filterType !== 'not-values' && ['date', 'datetime64[ns]'].includes(format)) {
    if (values.length <= 0) return <></>;
    switch (filterType) {
      case 'specific_date':
        return (
          <FilterBySpecificDate
            values={values}
            handle={handle}
            orientation={orientation}
            atModal={atModal}
          />
        );
      case 'not-after':
      case 'after':
      case 'not-before':
      case 'before':
      case 'not-after_inc':
      case 'after_inc':
      case 'not-before_inc':
      case 'before_inc':
        return (
          <FilterByNDate
            values={values}
            handle={handle}
            orientation={orientation}
            atModal={atModal}
          />
        );
      case 'not-between':
      case 'between':
      case 'not-between_inc':
      case 'between_inc':
        return (
          <FilterBetweenDates
            values={values}
            handle={handle}
            orientation={orientation}
            atModal={atModal}
          />

        );
      default:
        return (
          <FilterByN
            values={values}
            handle={handle}
            orientation={orientation}
            atModal={atModal}
            selector={selector}
            filterType={filterType}
          />
        );
    }
  } else {
    switch (filterType) {
      case 'not-values':
      case 'values':
        return <FilterByValues options={options} values={values} handle={handle} />;
      case 'not-between':
      case 'between':
      case 'not-between_inc':
      case 'between_inc':
        return (
          <FilterBetweenAB
            values={values}
            handle={handle}
            orientation={orientation}
            atModal={atModal}
          />
        );
      case 'not-contains':
      case 'contains':
        return (
          <FilterBySearch
            values={values}
            handle={handle}
            orientation={orientation}
            atModal={atModal}
          />
        );
      default:
        return (
          <FilterByN
            values={values}
            handle={handle}
            orientation={orientation}
            atModal={atModal}
            selector={selector}
            filterType={filterType}
          />
        );
    }
  }
};

KpiFilter.propTypes = {
  filterType: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.any),
  values: PropTypes.arrayOf(PropTypes.any),
  handle: PropTypes.func,
  format: PropTypes.string,
  orientation: PropTypes.string,
  atModal: PropTypes.bool,
  selector: PropTypes.string,
};

export default KpiFilter;
